import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

// mingcute:formula-fill — the Σ/formula glyph on the "Formula" collapsible header (ticket 7127,
// screen 16, Figma node 15986:2983). Brand-gradient filled. Drawn in a 16px box (glyph 10x14.2).
export const FormulaSvg: React.FC<Props> = ({ size = 16, style, className }) => {
  const colors = useStateSelector((state) => state.theme.colors);
  const id = `formula_${Math.random().toString(36).slice(2)}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <g transform="translate(3 1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.18847e-07 1.33333C1.18847e-07 0.979711 0.140476 0.640573 0.390524 0.390524C0.640573 0.140476 0.979711 0 1.33333 0H8.66667C9.02029 0 9.35943 0.140476 9.60947 0.390524C9.85952 0.640573 10 0.979711 10 1.33333V1.66667C10.0004 1.90283 9.91711 2.13149 9.76503 2.31216C9.61294 2.49283 9.40182 2.61384 9.16906 2.65376C8.9363 2.69369 8.69692 2.64995 8.49332 2.53029C8.28972 2.41063 8.13503 2.22278 8.05667 2H2.148L6.25867 5.52333C6.37554 5.62347 6.46935 5.74771 6.53368 5.88753C6.598 6.02735 6.6313 6.17943 6.6313 6.33333C6.6313 6.48724 6.598 6.63932 6.53368 6.77914C6.46935 6.91895 6.37554 7.0432 6.25867 7.14333L2.148 10.6667H8.05667C8.13503 10.4439 8.28972 10.256 8.49332 10.1364C8.69692 10.0167 8.9363 9.97298 9.16906 10.0129C9.40182 10.0528 9.61294 10.1738 9.76503 10.3545C9.91711 10.5352 10.0004 10.7638 10 11V11.3333C10 11.687 9.85952 12.0261 9.60947 12.2761C9.35943 12.5262 9.02029 12.6667 8.66667 12.6667H1.33333C0.979711 12.6667 0.640573 12.5262 0.390524 12.2761C0.140476 12.0261 1.18847e-07 11.687 1.18847e-07 11.3333V10.4867C1.50636e-05 10.2944 0.0416084 10.1044 0.121928 9.92975C0.202248 9.75507 0.319394 9.59983 0.465333 9.47467L4.13 6.33333L0.465333 3.19267C0.319308 3.06743 0.202112 2.91208 0.121789 2.73728C0.0414658 2.56248 -8.10993e-05 2.37237 1.18847e-07 2.18V1.33333Z"
          fill={`url(#${id})`}
        />
      </g>
      <defs>
        <linearGradient id={id} x1="3" y1="1" x2="13.5" y2="3.4" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
